import { enUS, ru, uk, Locale } from 'date-fns/locale';
import { useEffect, useState } from 'react';

export const useDateFsnLocale = (currentLocale: string) => {
  const [fnsLocale, setFsnLocale] = useState<Locale>();

  const getFsnLocale = (locale: string) => {
    switch (locale) {
      case 'en':
        return enUS;
      case 'ru':
        return ru;
      default:
        return uk;
    }
  };

  useEffect(() => {
    setFsnLocale(getFsnLocale(currentLocale));
  }, [currentLocale]);

  return { fnsLocale };
};
